// import { element } from "protractor";
import { AuthenticationService } from "@alfresco/adf-core";
import { HttpEventType, HttpResponse } from "@angular/common/http";
import { Component, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { DISABLED } from "@angular/forms/src/model";
import { MatPaginator, MatSort, MatTableDataSource } from "@angular/material";
import { MatDialog } from "@angular/material/dialog";
import {
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { ConfigurarPastaServiceService } from "app/configurar-pasta-service.service";
import { IncluirUriAlfrescoComponent } from "app/incluir-uri-alfresco/incluir-uri-alfresco.component";
import { ClienteModel } from "app/model/cliente/cliente.model";
import { ResponsePageable } from "app/model/cliente/pageable/responsePageable.model";
import { ClienteService } from "app/service/cliente/cliente.service";
import { PermissoesService } from "app/service/usuario/permissoes.service";
import { ManterModelComponent } from "./manter-model/manter-model.component";

// import { AppModule } from 'app/app.module';
// import { Atributo, Operador } from 'app/components/caixa/pesquisa-caixa-avancada/pesquisa-caixa-avancada.component';
// import { ClienteModel } from 'app/model/cliente/cliente.model';
// import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';

@Component({
  selector: "app-importar-modelo",
  templateUrl: "./importar-modelo.component.html",
  styleUrls: ["./importar-modelo.component.scss"],
})
export class ImportarModeloComponent implements OnInit {
  public page: ResponsePageable;
  idCliente = {} as ClienteModel;
  clientes: ClienteModel[];
  modelos: any[];
  fileToUpload: File | null = null;
  extensionXml = false;
  ext: String = "xml";
  orderForm: FormGroup;
  loading = true;
  horizontalPosition: MatSnackBarHorizontalPosition = "right";
  verticalPosition: MatSnackBarVerticalPosition = "top";

  private authorityArray: string[];
  public superUser = false;
  public editarModelo = false;
  public addModelo = false;
  public ativarDesativarModelo = false;
  public arrayString: string;

  itensPermissions = [
    "ATIVAR_DESATIVAR_MODELO",
    "ADD_MODELO",
    "EDIT_MODELO",
    "SUPER_USER",
  ];

  displayedColumns = [
    "id",
    "name",
    "description",
    "author",
    "namespace",
    "prefix",
    "lastUpdate",
    "status",
    "actions",
  ];

  dataSource = new MatTableDataSource<any[]>([]);
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(
    public service: ConfigurarPastaServiceService,
    private formBuilder: FormBuilder,
    private _snackBar: MatSnackBar,
    private authService: AuthenticationService,
    private router: Router,
    public dialog: MatDialog,
    private permissoesService: PermissoesService,
    private clienteService: ClienteService
  ) {}

  ngOnInit() {
    this.orderForm = this.formBuilder.group({
      file: File,
    });
    this.getModelosAlfresco();
    this.listarClientesUsuario();
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  getModelosAlfresco() {
    this.service.getModelosAlfresco().subscribe(
      (dados) => {
        this.modelos = dados;
        this.dataSource.data = this.modelos;
        this.loading = false;
      },
      (err) => {
        console.error(err);
        this.loading = false;
      }
    );
  }

  handleFileInput(files: FileList) {
    this.fileToUpload = files.item(0);
    const extension = this.getExtension(this.fileToUpload.name);
    if (this.ext === extension) {
      this.extensionXml = true;
    } else {
      this.extensionXml = false;
    }
  }

  getExtension(filename) {
    return (
      filename.substring(filename.lastIndexOf(".") + 1, filename.length) ||
      filename
    );
  }

  enviarArquivo() {
    this.loading = true;
    const formData: FormData = new FormData();
    formData.append("file", this.fileToUpload, this.fileToUpload.name);
    this.service.enviarModeloAlfresco(this.fileToUpload).subscribe(
      (event) => {
        if (event.type === HttpEventType.UploadProgress) {
          console.log("em andamento");
        } else if (event instanceof HttpResponse) {
          this.service.getModelosAlfresco().subscribe((dados) => {
            this.atualizarModelos();
          });
          this.loading = false;
          this.openSnackBarSuccess("Importação realizada com sucesso !");
        }
      },
      (err) => {
        this.loading = false;
        this.openSnackBarError("Erro ao enviar arquivo !");
      }
    );
  }

  atualizarModelos() {
    this.loading = true;
    this.service.getModelosAlfresco().subscribe((dados) => {
      this.modelos = dados;
      this.loading = false;
    });
  }

  // SnackBares
  openSnackBarSuccess(message: string) {
    this._snackBar.open(message, "", {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 4000,
      panelClass: ["success-snackbar"],
    });
  }

  openSnackBarError(message: string) {
    this._snackBar.open(message, "", {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 3000,
      panelClass: ["error-snackbar"],
    });
  }

  NovoModelo(element?): void {
    const dialogRef = this.dialog.open(ManterModelComponent, {
      width: '100%',
      data: { modelo: element },
    });
    dialogRef.afterClosed().subscribe(
      (result) => {
        if (result) {
          this.getModelosAlfresco();
        }
      },
      (error) => {
        console.error(error);
      }
    );
  }

  clearPerm() {
    this.superUser = false;
    this.editarModelo = false;
    this.addModelo = false;
    this.ativarDesativarModelo = false;
  }

  getAuthority() {
    this.authorityArray.includes("SUPER_USER") ? (this.superUser = true) : null;
    this.authorityArray.includes("EDIT_MODELO")
      ? (this.editarModelo = true)
      : null;
    this.authorityArray.includes("ADD_MODELO") ? (this.addModelo = true) : null;
    this.authorityArray.includes("ATIVAR_DESATIVAR_MODELO")
      ? (this.ativarDesativarModelo = true)
      : null;
  }

  getClienteById(id: number) {
    this.clienteService.getClienteUnico(id).subscribe(
      (data) => {
        this.idCliente = data;
        console.log(data);
      },
      (err) => {
        console.error(err);
      }
    );
  }

  getPermissionCliente(idCliente) {
    this.authorityArray = [];
    this.idCliente;
    console.log(idCliente);
    this.permissoesService.getPermissionEmpresa(idCliente).subscribe(
      (data: any[]) => {
        //verifica se nenhuma permissão foi encontrada
        this.authorityArray = data.map((el) => el.authority);
        const itensPermissoes = [
          "ATIVAR_DESATIVAR_MODELO",
          "EDIT_MODELO",
          "SUPER_USER",
        ];
        if (
          !itensPermissoes.some(
            (e) => this.authorityArray.includes(e),
            console.log(this.authorityArray)
          )
        ) {
          return this.openSnackBar(
            "Você não tem as permissões necessárias",
            true
          );
        }
        this.getAuthority();
      },
      (err) => {
        console.error(err);
        // this.openSnackBar("Ocorreu um erro, tente novamente mais tarde", true);
      }
    );
  }

  onClickAction(idCliente: number) {
    this.getPermissionCliente(idCliente);
  }

  listarClientesUsuario() {
    this.clienteService.getClientesAll().subscribe(
      (data) => {
        this.clientes = data;
      },
      (err) => {
        console.error(err);
      }
    );
  }

  openSnackBar(message: string, isErr: boolean) {
    this._snackBar.open(message, "", {
      horizontalPosition: "right",
      verticalPosition: "top",
      duration: 3000,
      panelClass: isErr ? ["info-snackbar"] : ["success-snackbar"],
    });
  }

  isActive(id) {
    this.service.ativarDesativarModelo(id).subscribe(
      (data) => {
        console.log(data);
        this.getModelosAlfresco();
      },
      (error) => {
        console.error(error);
      }
    );
  }
}



// WEBPACK FOOTER //
// /app/src/app/importar-modelo/importar-modelo.component.ts